module.exports = __webpack_public_path__ + "img/documentos.ec289d21.png";